export const buildMenuItemUrl = (url: string, menuItemId: string) => `${url.replace(/\/+$/, "")}/${menuItemId}`
